export default __webpack_public_path__ + "static/media/logoLineUps.82e9253b.png";